import { FieldForValidation, ValidationError } from '~/pages/pages/edit/context/store/types';

export const PAGE_MAME_FIELD_NAME = 'pageName';
export const SLUG_FIELD_NAME = 'slug';

export const validationErrors: Record<FieldForValidation, ValidationError> = {
  [PAGE_MAME_FIELD_NAME]: 'You must enter a page name before you can save or update.',
  [SLUG_FIELD_NAME]: 'Please enter a valid slug value before saving your page.'
};
